import React from 'react';
import { CheckIcon, BookOpenIcon, ListChecksIcon, CalendarIcon } from 'lucide-react';
import { trackPurchaseClick } from '../utils/MetaPixel';
export const Solution = () => {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-321">
      <div className="max-w-7xl mx-auto" data-id="element-322">
        <div className="text-center mb-12" data-id="element-323">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-324">
            El Método 3C™ que transforma tu cocina
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-325">
            No eres "inconstante". Eres estratégico, si tienes un sistema.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-326">
          <div className="flex justify-center order-2 md:order-1" data-id="element-327">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rij2P2V1dYdfYbDZEfc2LB/7fef2dcc-33f9-46e3-aef0-0537d0a12c83.png" alt="Recetario Fit para Airfryer" className="rounded-lg shadow-xl w-full max-w-md" data-id="element-328" />
          </div>
          <div className="space-y-6 order-1 md:order-2" data-id="element-329">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-330">
              <div className="flex items-center gap-4 mb-3" data-id="element-331">
                <div className="bg-teal-100 p-2 rounded-full" data-id="element-332">
                  <CheckIcon className="h-6 w-6 text-teal-600" data-id="element-333" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-334">Crocante</h3>
              </div>
              <p className="text-gray-700 pl-12" data-id="element-335">
                Reglas simples para textura "wow" sin aceite.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-336">
              <div className="flex items-center gap-4 mb-3" data-id="element-337">
                <div className="bg-teal-100 p-2 rounded-full" data-id="element-338">
                  <ListChecksIcon className="h-6 w-6 text-teal-600" data-id="element-339" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-340">Control</h3>
              </div>
              <p className="text-gray-700 pl-12" data-id="element-341">
                Macros claros según tu objetivo (déficit, mantenimiento o
                músculo).
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-342">
              <div className="flex items-center gap-4 mb-3" data-id="element-343">
                <div className="bg-teal-100 p-2 rounded-full" data-id="element-344">
                  <CalendarIcon className="h-6 w-6 text-teal-600" data-id="element-345" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-346">
                  Consistencia
                </h3>
              </div>
              <p className="text-gray-700 pl-12" data-id="element-347">
                Plan semanal + batch cooking 2 veces por semana.
              </p>
            </div>
            <div className="mt-8 flex justify-center md:justify-start" data-id="element-348">
              <a href="https://organicecomm.com/cart/51818275930293:1" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-lg" onClick={trackPurchaseClick} data-id="element-349">
                Quiero mi recetario por $17 USD
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};